// extracted by mini-css-extract-plugin
export var calculatedBadge = "_x5-8";
export var container = "_x5-0";
export var radioDot = "_x5-5";
export var radioDotSelected = "_x5-6";
export var row = "_x5-1";
export var rowFirst = "_x5-2";
export var rowLast = "_x5-3";
export var rowSelected = "_x5-4";
export var strikethrough = "_x5-7";